import React, { useState } from 'react';
import { useRouter } from 'next/router';

import { HtmlSanitizer } from '@BICE_Vida/scp-components';

import { Col, Container, Row } from '../../designSystem/Container/Container';
import Text from '../../designSystem/Text';
import Breadcrumb from '../../designSystem/Breadcrumb';
import SearchBar from '../../designSystem/SearchBar';
import { SearchBarOptionsT } from '../../designSystem/SearchBar/SearchBar';

import styles from './HelpDeskContent.module.scss';

import routes from '../../utils/routes';
import { searchOverQuestion } from '../../utils/textFilter';

type HelpDeskContentT = {
  categories?: HelpDeskCategory[];
  breadcrumbPages: {
    label: string;
    url: string;
  }[];
  lateral?: JSX.Element | JSX.Element[];
  icon?: string;
  title: string;
  description?: string;
  content?: JSX.Element | JSX.Element[];
};

const HelpDeskContent = ({
  categories,
  breadcrumbPages,
  lateral,
  icon,
  title,
  description,
  content,
}: HelpDeskContentT) => {
  const router = useRouter();

  const options: SearchBarOptionsT[] = [];

  const [searchInput, setSearchInput] = useState<string>('');
  const [searchOptions, setSearchOptions] = useState<SearchBarOptionsT[]>([]);

  const filterOptions = (value: any, input: any) => searchOverQuestion(value.title, input);

  const handleClick = (data: HelpDeskCategory, value: HelpDeskQuestion) => {
    options.push({
      text: value.title,
      onClick: () => {
        router.push(`${routes.helpDesk}/${data.categoryKeyword}/${value.keyword}`);
      },
    });
  };

  const onChangeSearchHandler = (event: any) => {
    const newSearchInput = event.target.value;
    setSearchInput(newSearchInput);

    if (newSearchInput.length > 2) {
      categories?.map((data: HelpDeskCategory) => {
        data.questions
          .filter((value: HelpDeskQuestion) => filterOptions(value, newSearchInput))
          .map((value) => {
            handleClick(data, value);
          });
      });

      setSearchOptions(options);
    } else {
      setSearchOptions([]);
    }
  };

  const onPressEnterSearchHandler = (search: string) => {
    if (search.length > 2) {
      router.push({
        pathname: routes.helpDeskSearch,
        query: {
          search,
        },
      });
    }
  };

  const onClickBreadcrumb = (url: string) => router.push(url);

  return (
    <Container className={styles.help_desk_container}>
      <Row>
        <Col className={styles.help_desk_section_header}>
          <Breadcrumb
            pages={breadcrumbPages}
            onClick={onClickBreadcrumb}
            initialPageText="Inicio"
            initialPageUrl={routes.helpDesk}
          />

          <SearchBar
            className={styles.help_desk_content_searchbar}
            value={searchInput}
            onChange={onChangeSearchHandler}
            options={searchOptions}
            onPressEnter={onPressEnterSearchHandler}
          />
        </Col>
      </Row>

      <Row cols={1}>
        <Col sm={12} md={4} lg={4} xl={3}>
          {lateral || <div />}
        </Col>
        <Col sm={12} md={8} lg={7} xl={7}>
          <div className={styles.help_desk_section_title_container}>
            {icon && (
              <img
                src={icon}
                alt="bicevida centro ayuda"
                className={styles.help_desk_section_icon}
              />
            )}
            <Text text={title} customClass={styles.help_desk_section_title} />
          </div>

          {description && (
            <HtmlSanitizer className={styles.help_desk_section_description} html={description} />
          )}

          {content && <div className={styles.help_desk_section_content}>{content}</div>}
        </Col>
        <Col sm={12} md={12} lg={1} xl={2}>
          <div />
        </Col>
      </Row>
    </Container>
  );
};

export default HelpDeskContent;
